/* A constant that is used to define the content type of the request. */
export const CONTENT_TYPES = {
	OCTET_STREAM: 'application/octet-stream',
	APPLICATION_JSON: 'application/json',
	FORM_DATA: 'multipart/form-data'
};

